import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuitTimelinePage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.quitTimeline.heading')}
      buttons={[
        {
          text: t('pages.onboarding.quitTimeline.options.within-1-month'),
          value: 'within-1-month',
        },
        {
          text: t('pages.onboarding.quitTimeline.options.within-3-months'),
          value: 'within-3-months',
        },
        {
          text: t('pages.onboarding.quitTimeline.options.within-6-months'),
          value: 'within-6-months',
        },
        {
          text: t('pages.onboarding.quitTimeline.options.gradual-reduction'),
          value: 'gradual-reduction',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
